import { IEnvInformation } from "./authentication/authSettings";

export const loadScript = (id: string, url: string) => {
    if(typeof window === "undefined" && document.getElementById(id) !== null){
        return;
    }
    const script = document.createElement("script");
    script.type = "module";
    script.src = url;
    script.id = id;
    document.head.appendChild(script);
  };

export const initLocalStorageForFragments = (envSettings: IEnvInformation) => {
    localStorage.setItem('aks_api_base_url',envSettings.apiBaseURL);
    localStorage.setItem('blender_url', envSettings.blenderUrl);
    localStorage.setItem('gara_url', envSettings.blenderUrl);
    localStorage.setItem('portal_url', envSettings.portalUrl);
};

export const loadFragments = (envSettings: IEnvInformation) => {
    initLocalStorageForFragments(envSettings);
    loadScript("directory-fragment", envSettings.fragmentsBaseUrl + "directory-listing-fragment.js");
    loadScript("performance-dashboard-fragment", envSettings.fragmentsBaseUrl + "agent-performance-dashboard-fragment.js");
}